import React, { createContext, useContext, useMemo, useState } from 'react';
import { useRouter } from '@edreamsodigeo/frontend-core';

const ItineraryTripContext = createContext();
const ItineraryTripActionsContext = createContext();

const ItineraryTripProvider = ({ children }) => {
  const [isOpen, setOpen] = useState(false);
  const { push } = useRouter();
  const actions = useMemo(
    () => ({
      open: (params) => {
        if (params) {
          push({
            pathname: 'checkout_flight_summary_results/[params]/',
            query: {
              params,
            },
          });
        } else {
          setOpen(true);
        }
      },
      close: () => setOpen(false),
    }),
    [push, setOpen]
  );

  return (
    <ItineraryTripContext.Provider value={isOpen}>
      <ItineraryTripActionsContext.Provider value={actions}>
        {children}
      </ItineraryTripActionsContext.Provider>
    </ItineraryTripContext.Provider>
  );
};

export const useIsOpenItineraryTrip = () => useContext(ItineraryTripContext);
export const useItineraryTripActions = () =>
  useContext(ItineraryTripActionsContext);

export default ItineraryTripProvider;
